import {
    HistoryMessage,
    HistoryMessageAlme, HistoryMessageError,
    HistoryMessageUser,
} from "../../../../types/history";


//#region Action Interfaces

interface AppendErrorAction
{
    type: 'APPEND_ERROR_MESSAGE';
    payload: {
        message: HistoryMessage;
        stateLocation: string;
    };
}

interface AppendHistoryMessageAction
{
    type: 'APPEND_HISTORY_MESSAGE';
    payload: {
        message: HistoryMessage;
        stateLocation: string;
    };
}

interface AppendReceivedResponseAction
{
    type: 'APPEND_RECEIVED_RESPONSE';
    payload: {
        message: HistoryMessage;
        stateLocation: string;
    };
}

interface AppendSentInputAction
{
    type: 'APPEND_SENT_INPUT';
    payload: {
        message: HistoryMessage;
        stateLocation: string;
    };
}

//#endregion



//#region ActionTypes

export type AppendHistoryActionTypes = AppendHistoryMessageAction |
                                       AppendReceivedResponseAction |
                                       AppendSentInputAction |
                                       AppendErrorAction;

//#endregion



//#region Action Constructors

export function appendError(message: HistoryMessageError, stateLocation: string): AppendHistoryActionTypes
{
    return {
        type: 'APPEND_ERROR_MESSAGE',
        payload: {
            message,
            stateLocation,
        },
    };
}

export function appendReceivedResponse(message: HistoryMessageAlme, stateLocation: string): AppendHistoryActionTypes
{
    return {
        type: 'APPEND_RECEIVED_RESPONSE',
        payload: {
            message,
            stateLocation,
        },
    };
}

export function appendSentInput(message: HistoryMessageUser, stateLocation: string): AppendHistoryActionTypes
{
    return {
        type: 'APPEND_SENT_INPUT',
        payload: {
            message,
            stateLocation,
        },
    };
}

//TODO: update lib-end-session to use this instead of local definition
export function appendHistoryMessage(message: HistoryMessage, stateLocation: string): AppendHistoryActionTypes
{
    return {
        type: 'APPEND_HISTORY_MESSAGE',
        payload: {
            message,
            stateLocation,
        },
    };
}

//#endregion



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/history-appender-maskedinput/src/actions/actions.ts